<template>
    <div>
        <div v-if="!show && is_auth === 0">
            <img class="homepic" src="@/assets/4.png">
            <div style="margin: 20px auto;">
                <div class="text1">您的身份信息暂未完善请前往提交</div>
                <div class="text2">Your identity information is not yet complete. Please go and submit it</div>
            </div>
            <div>
                <el-button type="primary" v-if="is_auth === 0 && is_auth_check === 0"
                    @click="goEdit">去完善身份信息</el-button>
            </div>
        </div>
        <div v-if="!show && is_auth === 1 && is_auth_check === 1 && isHome">
            <img class="homepic" src="@/assets/5.png">
            <div style="margin: 20px auto;">
                <div class="text1">欢迎登录供应商招标管理系统</div>
                <div class="text2">Welcome to log in to the supplier bidding management system</div>
                <div style="margin-top: 20px;">
                    <!-- <el-button v-if="is_auth === 1 && is_auth_check != 0" @click="goEdit">编辑信息</el-button> -->
                </div>
            </div>
        </div>
        <div v-if="!show && is_auth === 1 && is_auth_check === 2">
            <img class="homepic" src="@/assets/4.png">
            <div style="margin: 20px auto;">
                <div class="text1">您的身份信息审核失败</div>
                <div class="text2" style="color: #F56C6C;">失败原因：{{ userData.fail_reason }}</div>
                <div class="text2">Your identity information is not yet complete. Please go and submit it</div>
            </div>
            <div><el-button type="primary" @click="goEdit">去完善身份审核信息</el-button></div>
        </div>
        <div v-if="!show && is_auth === 1 && is_auth_check === 5">
            <img class="homepic" src="@/assets/4.png">
            <div style="margin: 20px auto;">
                <div class="text1">业务部审核通过,请等待综合部审核。</div>
                <div class="text2">Your identity information is not yet complete. Please go and submit it</div>
            </div>
            <!-- <div><el-button type="primary" @click="goEdit">去完善身份审核信息</el-button></div> -->
        </div>
        <div v-if="!show && is_auth === 1 && is_auth_check === 0">
            <img class="homepic" src="@/assets/4.png">
            <div style="margin: 20px auto;">
                <div class="text1">您的身份信息审核中</div>
                <div class="text2">Your identity information is not yet complete. Please go and submit it</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        userData: {
            type: Object,
            default: () => { }
        },
        show: {
            type: Boolean,
            default: false
        },
        isHome: {
            type: Boolean,
            default: false
        },
        is_auth: {
            type: Number,
            default: null
        },
        is_auth_check: {
            type: Number,
            default: null
        },


    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

        goEdit() {
            this.$emit('goEdit')
        }
    }
}
</script>

<style scoped>
.tishi {
    font-weight: 400;
    font-size: 14px;
    color: #E90000;
    margin-top: 20px;
}

.pm-box {
    width: 100%;
    height: 100%;
    padding: 10px 25px;
    box-sizing: border-box;
    background: #fff;
}

.text2 {
    font-weight: 400;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 28px;
}

.text1 {
    font-weight: 400;
    font-size: 40px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 41px;
}

.homepic {
    width: 328px;
    height: 379px;
}

.home {
    width: 100%;
    height: 100%;
    background: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/AuthCheck.vue